import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ISearchInitialStateInterface } from "../../types/reduxSlices";
import { IProduct } from "../../types/api";
import { IDrugCard } from "../../types/apis/drugs";

const initialState: ISearchInitialStateInterface = {
  Drug: null,
  Product: null,
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    handleGetSearchDrug: (state, action: PayloadAction<IDrugCard>) => {
      state.Drug = action.payload;
    },
    handleGetSearchProduct: (state, action: PayloadAction<IProduct>) => {
      state.Product = action.payload;
    },
  },
});

export const { handleGetSearchDrug, handleGetSearchProduct } =
  searchSlice.actions;

export default searchSlice.reducer;
